export const AssetVI = {
    "asset": {
        "header": {
            "title": "Danh sách tài sản",
            "titleAdd": "Tạo mới tài sản",
            "titleUpdate": "Cập nhật tài sản",
            "titleDetail": "Chi tiết tài sản",
            "titleAddPrivateProperty": "Tạo mới thuộc tính riêng",
            "titleAmountProduct": "Khối lượng sản phẩm hoàn thành"
        },
        "columns": {
            "code": "Mã TS",
            "assetCode": "Mã tài sản",
            "name": "Tên tài sản",
            "category": "Danh mục",
            "buyDate": "Ngày mua",
            "quantity": "Số lượng",
            "unit": "Đơn vị",
            "handoverQuantity": "Đang cấp phát",
            "remainQuantity": "SL còn lại",
            "status": "Trạng thái",
            "propertyValues": "Thuộc tính",
            "priceInitial": "Nguyên giá",
            "store": "Kho",
            "supplier": "Nhà cung cấp",
            "serialNumber": "Model / Series",
            "warranty": "Thời gian bảo hành (tháng)",
            "expirationDate": "Ngày hết hạn bảo hành",
            "priceInit": "Đơn giá",
            "depreciation": "Khấu hao (tháng)",
            "price": "Giá trị còn lại",
            "description": "Ghi chú",
            "storeManage": "Kho quản lí",
            "employeeRecipient": "Người sử dụng",
            "departmentRecipient": "Phòng ban sử dụng",
            "isReplication": "Nhân bản tài sản",
            "assetCodeFrom": "Mã tài sản từ",
            "assetCodeTo": "Mã tài sản đến",
            "barcode": "Barcode",
            "department": "Phòng ban quản lý",
            "position": "Vị trí tài sản",
            "type": "Loại tài sản",
            "handoverAction": "Đã cấp phát",
            "invokeAction": "Đã thu hồi",
            "wattage": "Sản lượng theo công suất thiết kế",
            "amountProduct": "Khối lượng sản phẩm",
            "month": "Tháng",
            "property": "Loại thuộc tính",
            "calculate": "Cách tính khấu hao"
        },
        "placeholder": {
            "code": "Nhập mã tài sản",
            "name": "Nhập tên tài sản",
            "category": "Chọn danh mục",
            "state": "Chọn tình trạng",
            "store": "Chọn kho quản lí",
            "supplier": "Chọn nhà cung cấp",
            "serialNumber": "Nhập Model / Series",
            "priceInit": "Nhập đơn giá",
            "depreciation": "Nhập khấu hao",
            "price": "Giá trị còn lại",
            "description": "Nhập ghi chú",
            "propertyValues": "Nhập giá trị thuộc tính",
            "barcode": "Nhập / sử dụng máy đọc mã vạch",
            "warranty": "Nhập thời gian bảo hành",
            "department": "Chọn phòng ban",
            "position": "Chọn vị trí",
            "type": "Chọn loại",
            "quantity": "Nhập số lượng",
            "unit": "Chọn đơn vị",
            "wattage": "Nhập sản lượng",
            "amountProduct": "Nhập khối lượng sản phẩm",
            "property": "Vui lòng chọn loại thuộc tính",
            "calculate": "Nhập cách tính khấu hao"
        },
        "state": {
            "good": "Tốt",
            "normal": "Bình thường",
            "bad": "Hỏng"
        },
        "status": {
            "pending": "Chưa cấp phát",
            "handover": "Cấp phát",
            "invoke": "Thu hồi",
            "maintenance": "Bảo dưỡng, sửa chữa"
        },
        "tooltip": {
            "isReplication": "Cho phép nhập nhiều tài sản với mã khác nhau",
            "barcode": "Mã để in lên tem nhãn tài sản"
        },
        "message": {
            "deleteAsk": "Bạn có chắc chắn muốn xóa tài sản?"
        },
        "hanover": {
            "title-list": "Danh sách cấp phát",
            "titleAdd": "Thêm mới cấp phát",
            "titleEdit": "Sửa phiếu cấp phát",
            "titleDetail": "Chi tiết phiếu cấp phát",
            "col": {
                "code": "Mã cấp phát",
                "asset": "Tài sản",
                "checkdepartment": "Phòng ban được cấp phát",
                "department": "Phòng ban nhận",
                "employeeIdRecipient": "Nhười nhận",
                "employeeIdRecipient1": "Nhười đại diện nhận",
                "amount": "Số lượng",
                "inventory": "Tồn kho",
                "day": "Ngày cấp",
                "hour": "Giờ cấp",
                "position": "Vị trí tài sản",
                "status": "Trạng thái",
                "addressLocation": "Địa điểm bàn giao",
                "deposit": "Đặt cọc",
                "reasonHanover": "Lý do cấp phát"
            },
            "placeholder": {
                "asset": "Chọn tài sản",
                "position": "Chọn vị trí tài sản",
                "status": "Chọn trạng thái"
            },
            "status": {
                "using": "Đang sử dụng",
                "repair": "Sửa chữa , bảo hành",
                "liquidation": "Thanh lý",
                "broken": "Hỏng",
                "away": "Mất",
                "cancel": "Hủy"
            },
            "columns": {
                "department": "Phòng ban được cấp phát",
                "individual": "Cá nhân",
                "asset": "Mã TS",
                "asset-name": "Tài sản",
                "day": "Ngày cấp phát",
                "amount": "Số lượng",
                "amount-invoke": "Đã thu hồi",
                "check-department": "Cấp phát cho",
                "employee-recipient": "Nguời nhận",
                "department-recipient": "Phòng ban",
                "position": "Vị trí tài sản"
            },
            "tab": {
                "hanover": "Đang cấp phát",
                "invoke": "Đang thu hồi",
                "invoke-success": "Thu hồi xong"
            }

        },
        "tab": {
            "detail": "Chi tiết",
            "information": "Thông tin chung",
            "history": "Lịch sử thu hồi"
        },
        "modal-active": {
            "delete": "Bạn có chắc chắn muốn xóa?"
        },
        "action": {
            "cancel": "Báo hủy",
            "broken": "Báo hỏng",
            "repair": "Bảo hành, sửa chữa",
            "liquidation": "Thanh lý",
            "loss": "Báo mất",
            "increase": "Báo tăng",
            "columns": {
                "date": "Ngày",
                "action": "Tác vụ",
                "quantityBegin": "Tồn đầu kỳ",
                "quantity": "Số lượng",
                "quantityAfter": "Tồn cuối kỳ",
                "price": "Số tiền",
                "description": "Mô tả"
            }
        },
        "depreciationOption": {
            "straightLine": "Khấu hao theo đường thẳng",
            "decrease": "Khấu hao theo số dư giảm dần",
            "amount": "Khấu hao theo số lượng sản phẩm"
        }
    },
    "assetInvoke": {
        "header": {
            "title": "Danh sách thu hồi",
            "titleAdd": "Tạo mới thu hồi",
            "titleUpdate": "Cập nhật thu hồi",
            "titleDetail": "Chi tiết thu hồi"
        },
        "columns": {
            "invokeCode": "Mã thu hồi",
            "asset": "Tài sản",
            "handover": "Thu hồi cho lần cấp phát",
            "quantity": "Số lượng",
            "handoverQuantity": "Cấp phát / tổng",
            "invokeDate": "Ngày thu hồi",
            "invokeTime": "Thời gian thu hồi",
            "position": "Vị trí tài sản",
            "status": "Trạng thái",
            "invokeAddress": "Địa điểm thu hồi",
            "payDeposit": "Trả đặt cọc",
            "invokeReason": "Lý do thu hồi",
            "invoker": "Người thu hồi",
            "assetCode": "Mã tài sản",
            "invokeFrom": "Thu hồi từ",
            "employeeRecipient": "Người dùng",
            "departmentRecipient": "Phòng ban",
            "employeeRecipientName": "Người được cấp phát",
            "departmentRecipientName": "Phòng ban được cấp phát",
            "employee": "Cá nhân",
        },
        "placeholder": {
            "invokeCode": "Nhập mã thu hồi",
            "asset": "Chọn tài sản",
            "handover": "Chọn lần cấp phát",
            "quantity": "Nhập số lượng",
            "invokeTime": "Chọn thời gian thu hồi",
            "position": "Chọn vị trí tài sản",
            "status": "Chọn trạng thái",
            "invokeAddress": "Nhập địa điểm",
            "payDeposit": "Trả đặt cọc",
            "invokeReason": "Nhập lý do",
        },
        "status": {
            "using": "Đang sử dụng",
            "repair": "Sửa chữa, bảo hành",
            "liquidation": "Thanh lí",
            "broken": "Hỏng",
            "away": "Mất",
            "cancel": "Hủy"
        },
        "message": {
            "deleteAsk": "Bạn có chắc chắn muốn xóa lần thu hồi tài sản?"
        }
    },
    "assetAction": {
        "header": {
            "title": "Lịch sử cấp phát thu hồi",
            "title-store": "Lịch sử tồn kho"
        },
        "columns": {
            "actionDate": "Ngày",
            "code": "Mã",
            "actionType": "Hành động",
            "quantity": "Số lượng",
            "creator": "Người thực hiện",
            "handoverFor": "Bàn giao cho",
            "employeeRecipient": "Cá nhân / đại diện",
            "departmentRecipient": "Phòng ban",
            "assetEmployee": "Tài sản cá nhân",
            "assetDepartment": "Tài sản phòng ban"
        },
    },
    "assetInvokeNotification": {
        "header": {
            "repair": "Phiếu bảo hành, sửa chữa",
            "liquidation": "Phiếu thanh lí",
            "broken": "Phiếu báo hỏng",
            "away": "Phiếu báo mất",
            "cancel": "Phiếu báo hủy",
            "loss": "Phiếu báo mất ",
            "increase": "Phiếu báo tăng",
            "title": "Danh sách thông báo thu hồi"
        },
        "columns": {
            "repair": "Bảo hành, sửa chữa",
            "liquidation": "Thanh lí",
            "broken": "Báo hỏng",
            "away": "Báo mất",
            "cancel": "Báo hủy",
            "assetName": "Tên tài sản",
            "date": "Ngày báo",
            "quantity": "Số lượng",
            "amount": "Số tiền",
            "description": "Mô tả",
            "assetCode": "Mã TS",
            "reportDate": "Ngày báo",
            "reason": "Lý do",
            "createInvokeForm": "Tạo phiếu thu hồi",
            "createdForm": "Đã tạo phiếu",
            "notCreatedForm": "Chưa tạo phiếu"
        },
        "placeholder": {
            "quantity": "Nhập số lượng",
            "amount": "Nhập số tiền"
        }
    },
    "title": "Kho",
    "asset-deduct": {
        "title": "Danh sách khấu hao tài sản",
        "straight_line-calculate": "Khấu hao đường thẳng",
        "decrease-calculate" : "Khấu hao số dư giảm dần",
        "amount-calculate" : "Khấu hao số lượng sản phẩm",
        "code": "Mã TS",
        "name": "Tài sản",
        "groundName": "Nhóm TS",
        "day": "Ngày bắt đầu KH",
        "amount": "Số lượng",
        "price": "Đơn giá",
        "totalPrice": "Tổng tiền",
        "periodDepreciated": "Khấu hao",
        "depreciated": "Đã khấu hao",
        "remain": "Còn lại",

    }

}